function getLists({ userId = null, metadataId = null, category, page, size, sort = null }, apiClient) {
  const route = apiClient.route`/libraries/${':librarySubdomain'}/lists`;
  return apiClient.get(route, { query: { userId, metadataId, category, page, size, sort } });
}

export default {
  getLists
};
